<template lang="pug">
  .IncomeReport.card
    .top
      .filter-label
        .filters(v-if="incomeReportModel")
          .filter.income-type
            FormItem(
              type="select"
              field_name="report_types"
              :label_text=" 'Belge Türü' "
              select_label="name"
              track-by="value"
              :taggable="true"
              :multiple="false"
              :allowEmpty="false"
              :value="incomeReportModel.incomeType"
              v-model="incomeReportModel.incomeType"
              :options="availableIncomeTypes"
              :placeholder=" $t('generic.placeholder.choose') "
            )
          .filter.report-type
            FormItem(
              type="select"
              field_name="report_types"
              :label_text=" $t('income_report.field.report_type') "
              select_label="name"
              track-by="value"
              :taggable="true"
              :multiple="false"
              :allowEmpty="false"
              :value="incomeReportModel.reportType"
              v-model="incomeReportModel.reportType"
              :options="availableReportTypes"
              :placeholder=" $t('generic.placeholder.choose') "
            )
          .filter.main-metric
            FormItem(
              type="select"
              field_name="main_metric"
              :label_text=" $t('income_report.field.main_metric') "
              select_label="name"
              track-by="value"
              :taggable="true"
              :multiple="false"
              :allowEmpty="false"
              :value="incomeReportModel.reportMetric"
              v-model="incomeReportModel.reportMetric"
              :options="availableReportMetrics"
              :placeholder=" $t('generic.placeholder.choose') "
            )
          .filter.relative
            FilterButton(@click="onFiltersClick")
          .filter.relative
            DatePicker(
              ref="datePicker"
              v-model="date"
              :isAdvanced="true"
              @onClear="onDateFilterClear"
              :hasError="isAboveDateRangeLimit"
            )
          .filter.relative(v-if="isAboveDateRangeLimit")
            .u-text.u-color-red
              | {{ dateRangeErrorText }}

      FilterShow(
        v-if="hasFilters"
        :filters="filters"
        @clearFilter="onClearFilter")

      FilterSidebar(
        v-if="filterVisible"
        :filters="filters"
        @close="onFiltersClose")

      .loading(v-if="isLoading")
        Loading

    .seperator

    .bottom

      GridDataTable(
        ref="gridDataTable"
        v-if="gridDataTableModel"
        :model="gridDataTableModel"
      )
        template(slot="table-actions-left-side")
          .table-actions-left-side

        template(slot="table-actions-right-side" v-if="false")
          .table-actions-right-side
            .export(@click="onExportClick" v-if="tableHasData")
              | {{ $t('generic.action.export') }}

        template(slot="item" slot-scope="{item}")
          .text-with-variants(v-if="item.isTextAndVariantsItem")
            .text.u-text-ellipsis
              | {{ item.displayValue }}
            .variants(v-if="item.variants && item.variants.length")
              .variant(v-for="(variant, index) in item.variants") {{ (index > 0 ? "/ " : "") + variant }}
          .text.u-text-ellipsis(v-else)
            | {{ item.value !== null ? item.displayValue : "-"}}
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  import _debounce from 'lodash/debounce'

  import {Filter, FilterTypes} from '@/component/filter-sidebar/model'
  import FilterShow from '@/component/filter-show'
  import FilterSidebar from '@/component/filter-sidebar'
  import FilterButton from '@/component/filter-sidebar/filter-button'
  import DatePicker from '@/component/date-picker'

  import {ReportDateGroupBy, ReportIncome} from './model/income-report-model'
  import {AdvancedDatePickerItemType} from '@/component/advanced-date-picker/advanced-date-picker-model'
  import {
    GridDataTableRow,
    SortDirection
  } from '@/component/grid-data-table/grid-data-table-model'
  import {mapDateUtils} from '@/utils/date-utils'

  const WAIT_NAME = "incomeReport"

  const DATE_RANGE_LIMIT_DAY = 90
  const DATE_RANGE_LIMIT_WEEK = 52
  const DATE_RANGE_LIMIT_MONTH = 24
  const DATE_RANGE_LIMIT_QUARTER = 8
  const DATE_RANGE_LIMIT_YEAR = 2
  export default {
    name: "IncomeReport",
    components: {
      DatePicker,
      FilterShow,
      FilterSidebar,
      FilterButton
    },
    data() {
      return {
        incomeReportModel: null,
        date: null,
        searchKeyword: null,
        filterVisible: false
      }
    },
    watch: {
      date() {
        if (!this.$refs.datePicker) return

        this.$nextTick(() => {
          // Check for date range limits
          if (this.isAboveDateRangeLimit) {
            return
          }

          this.incomeReportModel.dateRange = this.date.range
          const selectedTabType = this.date.type
          switch (selectedTabType) {
            case AdvancedDatePickerItemType.DAY:
              this.incomeReportModel.groupBy = ReportDateGroupBy.DAY
              break;
            case AdvancedDatePickerItemType.WEEK:
              this.incomeReportModel.groupBy = ReportDateGroupBy.WEEK
              break;
            case AdvancedDatePickerItemType.MONTH:
              this.incomeReportModel.groupBy = ReportDateGroupBy.MONTH
              break;
            case AdvancedDatePickerItemType.QUARTER:
              this.incomeReportModel.groupBy = ReportDateGroupBy.QUARTER
              break;
            case AdvancedDatePickerItemType.YEAR:
              this.incomeReportModel.groupBy = ReportDateGroupBy.YEAR
              break;
            default:
              break;
          }
          this.getReport()
        })
      },
      reportMetric() {
        if (this.reportMetric)
          this.getReport()
      },
      reportType() {
        if (this.reportType)
          this.getReport()
      },
      incomeType() {
        if (this.incomeType)
          this.getReport()
      },
      searchKeyword: _debounce(function () {
        if (this.searchKeyword && this.searchKeyword.length > 1)
          this.incomeReportModel.gridDataTableModel.searchKeyword = this.searchKeyword
        else
          this.incomeReportModel.gridDataTableModel.searchKeyword = null
        this.$refs.gridDataTable.scrollTop()
      }, 150)
    },
    computed: {
      ...mapState('Vendor', [
        'vendor_list'
      ]),

      ...mapState('PaymentType', [
        'payment_type_list'
      ]),

      ...mapState('DocumentType', [
        'document_type_list'
      ]),

      ...mapState('Category', [
        'category_list'
      ]),

      ...mapState('Tag', [
        'tag_list'
      ]),

      availableIncomeTypes() {
        return this.incomeReportModel && this.incomeReportModel.availableIncomeTypes
      },
      availableReportTypes() {
        return this.incomeReportModel && this.incomeReportModel.availableReportTypes
      },
      availableReportMetrics() {
        return this.incomeReportModel && this.incomeReportModel.availableReportMetrics
      },
      gridDataTableModel() {
        return this.incomeReportModel ? this.incomeReportModel.gridDataTableModel : null
      },
      hoveredRowKey() {
        return this.gridDataTableModel.hoveredRowKey
      },
      hoveredColumnKey() {
        return this.gridDataTableModel.hoveredColumnKey
      },
      filters() {
        return this.incomeReportModel && this.incomeReportModel.filters
      },
      hasFilters() {
        return this.filters && this.filters.some(f => f.hasSelectedFilter)
      },
      isLoading() {
        return this.$wait.is(WAIT_NAME)
      },
      reportMetric() {
        return this.incomeReportModel && this.incomeReportModel.reportMetric
      },
      reportType() {
        return this.incomeReportModel && this.incomeReportModel.reportType
      },
      incomeType() {
        return this.incomeReportModel && this.incomeReportModel.incomeType
      },
      tableVisible() {
        return this.incomeReportModel && this.gridDataTableModel
      },
      tableHasData() {
        return this.tableVisible && this.gridDataTableModel.hasData
      },
      isAboveDateRangeLimit() {
        const dateRange = this.date.range
        if (!dateRange) return false
        const dates = dateRange.split(" - ")
        if (dates.length === 1) return false

        let dayDiff = null
        switch (this.date.type) {
          case AdvancedDatePickerItemType.DAY:
            dayDiff = this.getDayDiff(dates[0], dates[1], "YYYY-MM-DD", "days")
            return dayDiff >= DATE_RANGE_LIMIT_DAY
          case AdvancedDatePickerItemType.WEEK:
            dayDiff = this.getDayDiff(dates[0], dates[1], "YYYY-MM-DD", "weeks")
            return dayDiff >= DATE_RANGE_LIMIT_WEEK
          case AdvancedDatePickerItemType.MONTH:
            dayDiff = this.getDayDiff(dates[0], dates[1], "YYYY-MM-DD", "months")
            return dayDiff >= DATE_RANGE_LIMIT_MONTH
          case AdvancedDatePickerItemType.QUARTER:
            dayDiff = this.getDayDiff(dates[0], dates[1], "YYYY-MM-DD", "quarters")
            return dayDiff >= DATE_RANGE_LIMIT_QUARTER
          case AdvancedDatePickerItemType.YEAR:
            dayDiff = this.getDayDiff(dates[0], dates[1], "YYYY-MM-DD", "years")
            return dayDiff >= DATE_RANGE_LIMIT_YEAR
          default:
            return false
        }
      },
      dateRangeErrorText() {
        switch (this.date.type) {
          case AdvancedDatePickerItemType.DAY:
            return this.$t('income_report.msg.choose[0].period', [DATE_RANGE_LIMIT_DAY])
          case AdvancedDatePickerItemType.WEEK:
            return this.$t('income_report.msg.choose[1].period', [DATE_RANGE_LIMIT_WEEK])
          case AdvancedDatePickerItemType.MONTH:
            return this.$t('income_report.msg.choose[2].period', [DATE_RANGE_LIMIT_MONTH])
          case AdvancedDatePickerItemType.QUARTER:
            return this.$t('income_report.msg.choose[3].period', [DATE_RANGE_LIMIT_QUARTER])
          case AdvancedDatePickerItemType.YEAR:
            return this.$t('income_report.msg.choose[4].period', [DATE_RANGE_LIMIT_YEAR])
          default:
            return ""
        }
      }
    },
    methods: {
      ...mapActions('IncomeReport', [
        'fetchIncomeReport',
        'exportIncomeReport'
      ]),

      ...mapDateUtils([
        'getDayDiff'
      ]),

      onClearFilter(filter) {
        filter.clear()
        this.getReport()
      },
      onFiltersClick() {
        this.filterVisible = true
        this.$refs.datePicker.hide()
      },
      onFiltersClose(hasChange) {
        this.filterVisible = false
        if (hasChange) {
          this.getReport()
        }
      },
      onExportClick() {
        this.exportIncomeReport(this.incomeReportModel.exportRequestBody)
          .then(response => {
            const a = document.createElement('a')
            const url = window.URL.createObjectURL(response.data)
            a.href = url
            a.download = this.$t('income_report.field.report_name') + '.xls'
            a.click()
            window.URL.revokeObjectURL(url)
          })
          .catch(response => {
            console.log(response)
          })
      },
      onDateFilterClear() {
        this.incomeReportModel.groupBy = null
      },
      isRotatedSortArrow(column) {
        return column.sortDirection === SortDirection.ASC
      },
      isHeaderHighlighted(column) {
        return column.key === this.hoveredColumnKey
      },
      clearSearch() {
        this.searchKeyword = null
      },
      getReport() {
        this.fetchIncomeReport(this.incomeReportModel.requestBody)
          .then(response => {
            this.incomeReportModel.reportIncomeResponse = response.data
          })
          .catch(response => {
            console.log(response)
          })
      },
      init() {
        const $t = this.$t.bind(this)
        const self = this
        this.incomeReportModel = new ReportIncome({
          $t: $t,
          vendorList: self.vendor_list.list,
          paymentTypeList: self.payment_type_list.list,
          documentTypeList: self.document_type_list.list,
          categoryList: self.category_list.list,
          tagList: self.tag_list.list
        })
        this.date = {range: this.incomeReportModel.dateRange}
      }
    },
    mounted() {
      this.init()
    }
  }
</script>

<style lang="scss" scoped>
  .IncomeReport {
    height: calc(100vh - 80px);
    display: flex;
    flex-direction: column;

    .top {
      flex: 0 0 0;
      padding-bottom: 20px;
    }

    .seperator {
      width: calc(100% + 80px);
      position: relative;
      left: - 40px;
      height: 1px;
      background: #D4DBE3;
    }

    .filter-label {
      .filters {
        display: flex;
        align-items: center;

        .filter {
          flex: 0 0 auto;
          margin-right: 15px;


        }

        .apply-btn {
          background: $color-blue;
          padding: 10px;
          color: white;
          border-radius: 5px;
          user-select: none;
          cursor: pointer;
        }

        .relative {
          position: relative;
          top: 11px;
        }
      }
    }

    .bottom {
      flex: 1 0 0;
      overflow: hidden;
      margin-top: 20px;
      position: relative;
    }

    .loading {
      margin-top: 20px;
    }

    .table-actions-left-side {
    }

    .table-actions-right-side {
      display: flex;
      align-items: center;

      .export {
        background: #FFFFFF;
        border: 1px solid #35495E;
        color: #35495E;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        padding: 0 10px;
        border-radius: 5px;
        margin-left: 10px;
        cursor: pointer;
        user-select: none;
        font-weight: bold;
      }
    }

    .text-with-variants {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      padding: 5px 0;
      box-sizing: border-box;

      .text {
        flex: 5 0 0;
        display: flex;
        align-items: flex-end;
      }

      .variants {
        flex: 4 0 0;
        display: flex;

        .variant {
          display: flex;
          align-items: center;
          justify-content: center;
          color: $color-blue;
          margin-right: 5px;
          font-size: 12px;
          border-radius: 5px;
          font-weight: 400;
        }
      }
    }

  }
</style>